import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { ScreenBskRoutes } from './screenbsk.routes';
import { ListScreenBskComponent } from './list-screenbsk/list-screenbsk.component';
import { FormScreenBskComponent } from './_components/form-screenbsk/form-screenbsk.component';
import { AddScreenBskComponent } from './add-screenbsk/add-screenbsk.component';
import { EditScreenBskComponent } from './edit-screenbsk/edit-screenbsk.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        ScreenBskRoutes,
        SharedDocumalisModule,
        TranslateModule,
        FormScreenBskComponent,
    ],
    declarations: [
        ListScreenBskComponent,
        AddScreenBskComponent,
        EditScreenBskComponent,
    ]
})
export class ScreenBskModule { }
